import { Meta } from "@/shared/components";
import { Disputes } from "@/admin/features/disputes";

export function DisputesPage() {
  return (
    <>
      <Meta title="Диспуты" />
      <Disputes />
    </>
  );
}
